import { FieldErrors } from "react-hook-form";
import InputErrorMessage from "../../components/InputErrorMessage";
import HelperTextEnum from "../enums/helper-text.enum";
import React from "react";

function handleHelperText(errors: FieldErrors, name: string) {
	if (errors[name]) {
		return <InputErrorMessage errors={errors} name={name} />;
	} else {
		return HelperTextEnum[name as keyof typeof HelperTextEnum];
	}
}

export { handleHelperText };
